import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './styles/global.css';
import App from './App';
import ImageProtection from './ImageProtection';
import './index.css';

const rootElement = document.getElementById('root');
const rootContent = (
  <React.StrictMode>
    <ImageProtection>
      <App />
    </ImageProtection>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, rootContent);
} else {
  createRoot(rootElement).render(rootContent);
}
